import { gql } from "@apollo/client";

export const GET_DASHBOARD_STATS = gql`
  query GetDashboardStats($spaceId: ID) {
    getDashboardStats(spaceId: $spaceId) {
      totalEventTypes
      totalBookings
      confirmedBookings
      pendingBookings
      canceledBookings
      rejectedBookings
      upcomingBookings
      completedBookings
      rescheduledBookings
      monthlyBookingStats {
        month
        year
        totalBookings
        confirmedBookings
        canceledBookings
      }
      recentBookings {
        id
        name
        email
        date
        timeStart
        timeEnd
        status
        notes
        eventTypeId
      }
      eventTypeStats {
        eventType {
          id
          title
          duration
          description
        }
        totalBookings
        completedBookings
        canceledBookings
      }
      availabilityStatus
    }
  }
`;
